import React from "react";
import { useDispatch } from "react-redux";

import {
  makeStyles,
  Typography,
  Card,
  CardMedia,
  CardContent,
  IconButton
} from "@material-ui/core";
import { Cancel } from "@material-ui/icons";

import { removeCreative } from "../../../actions/app/creatives";

const content = {
  paddingBottom: 0,
  padding: 12,
  textAlign: "left"
};

const useStyles = makeStyles((theme) => ({
  verticalCard: {
    maxWidth: 220,
    margin: 10,
    position: "relative",
    paddingRight: theme.spacing(1),
    paddingLeft: theme.spacing(1),
    paddingTop: theme.spacing(6)
  },
  horizontalCard: {
    maxWidth: 460,
    margin: 10,
    position: "relative",
    paddingRight: theme.spacing(1),
    paddingLeft: theme.spacing(1),
    paddingTop: theme.spacing(6)
  },
  verticalMedia: {
    width: 120,
    margin: "0 auto"
  },
  horizontalMedia: {
    width: 360,
    margin: "0 auto"
  },
  icon: {
    position: "absolute",
    right: 0,
    top: 0
  },
  name: {
    wordBreak: "break-all"
  },
  typography: {
    wordBreak: "break-all",
    paddingBottom: theme.spacing(1)
  }
}));

const AssetPreview = ({ asset, isThumbnailEnabled }) => {
  let orientation = "";
  let height = null;
  let width = null;
  if (asset.dcmCreative) {
    height = asset.dcmCreative.size.height;
    width = asset.dcmCreative.size.width;
    if (height > width) {
      orientation = "vertical";
    } else if (height <= width) {
      orientation = "horizontal";
    }
  } else if (asset.dimensions !== "N/A") {
    height = parseInt(asset.dimensions.split("x")[1]);
    width = parseInt(asset.dimensions.split("x")[0]);
    if (height > width) {
      orientation = "vertical";
    } else if (height <= width) {
      orientation = "horizontal";
    }
  }

  const classes = useStyles();
  const dispatch = useDispatch();

  const updateDimensions = () => {
    if (asset.dcmCreative !== undefined) {
      return `${asset.dcmCreative.size.width} x ${asset.dcmCreative.size.height}`;
    } else if (asset.dimensions === "N/A") {
      if (asset.file.type !== undefined && asset.file.type.includes("video")) {
        return "0 x 0";
      }
      return asset.dimensions;
    } else {
      return asset.dimensions;
    }
  };

  return (
    <Card
      className={
        orientation === "vertical"
          ? classes.verticalCard
          : classes.horizontalCard
      }
    >
      <IconButton
        className={classes.icon}
        onClick={() => dispatch(removeCreative(asset.id))}
      >
        <Cancel filled="true" color="action" />
      </IconButton>
      {isThumbnailEnabled && asset.preview ? (
        <CardMedia
          component="img"
          image={asset.preview ? asset.preview : ""}
          title={asset.file.name}
          key={asset.id}
          classes={
            orientation === "vertical"
              ? { media: classes.verticalMedia }
              : { media: classes.horizontalMedia }
          }
        />
      ) : null}
      <CardContent style={content}>
        {asset.taxonomy.name ? (
          <Typography
            variant="body2"
            color="textSecondary"
            component="p"
            className={classes.typography}
          >
            Creative name: {asset.taxonomy.name}
          </Typography>
        ) : null}
        <Typography
          variant="body2"
          color="textSecondary"
          component="p"
          className={classes.typography}
        >
          File name: {asset.file.name ? asset.file.name : asset.name}
        </Typography>
        <Typography variant="body2" color="textSecondary" component="p">
          Dimensions: {updateDimensions()}
        </Typography>
      </CardContent>
    </Card>
  );
};

export default AssetPreview;
